import axios from 'axios'
import { Toast, Dialog } from 'vant'
import store from '../store'
import router from '../router'
import cache from './cache'
import errorCode from './errorCode'
import { getToken } from './auth'
import { tansParams } from './validate'
axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'
let server = axios.create({
  baseURL: process.env.BASE_API,
  // 超时
  timeout: 15000
})
// 添加请求拦截器
server.interceptors.request.use(
  function(config) {
    const isToken = (config.headers || {}).isToken === false
    // 是否需要防止数据重复提交
    const isRepeatSubmit = (config.headers || {}).repeatSubmit === false
    // 在发送请求之前做些什么
    if (getToken() && !isToken) {
      config.headers['Authorization'] = getToken() // 让每个请求携带自定义token 请根据实际情况自行修改
    } else if (!getToken() && !isToken) {
      if (config.url == 'oauth/login') {
        // 登录的请求头
        config.headers['Authorization'] = 'Basic ZG91eWluLW9jZWFuLWtub3dzOm9jZWFub2F1dGgxMjMuLg=='
      } else {
        config.headers['Authorization'] = ''
      }
    }

    // get请求映射params参数
    if (config.method === 'get' && config.params) {
      let url = config.url + '?' + tansParams(config.params)
      url = url.slice(0, -1)
      config.params = {}
      config.url = url
    }

    if (!isRepeatSubmit && (config.method === 'post' || config.method === 'put')) {
      const requestObj = {
        url: config.url,
        data: typeof config.data === 'object' ? JSON.stringify(config.data) : config.data,
        time: new Date().getTime()
      }
      const sessionObj = cache.session.getJSON('sessionObj')
      if (sessionObj === undefined || sessionObj === null || sessionObj === '') {
        cache.session.setJSON('sessionObj', requestObj)
      } else {
        const s_url = sessionObj.url // 请求地址
        const s_data = sessionObj.data // 请求数据
        const s_time = sessionObj.time // 请求时间
        const interval = 500 // 间隔时间(ms)，小于此时间视为重复提交
        if (s_data === requestObj.data && requestObj.time - s_time < interval && s_url === requestObj.url) {
        } else {
          cache.session.setJSON('sessionObj', requestObj)
        }
      }
    }
    return config
  },
  function(error) {
    // 对请求错误做些什么
    return Promise.reject(error)
  }
)

// 添加响应拦截器
server.interceptors.response.use(
  function(res) {
    // 对响应数据做点什么
    // 未设置状态码则默认成功状态

    const code = res.data.code || 200
    // 获取错误信息
    const msg = errorCode[code] || res.data.msg || errorCode['default']
    // 二进制数据则直接返回
    if (res.request.responseType === 'blob' || res.request.responseType === 'arraybuffer') {
      return res.data
    }
    if (code === '401' || res.status === 401) {
      Dialog.confirm({
        showCancelButton: false,
        title: '温馨提示',
        message: '登录状态已过期,请重新登陆'
      }).then(() => {
        store.dispatch('LogOut').then(() => {
          router.replace({
            path: '/login',
            query: {
              redirect: router.currentRoute.fullPath
            }
          })
        })
      })
      return Promise.reject('登录状态已过期，请重新登录。')
    } else if (code == 33004) {
      return {
        code: 33004,
        data: {
          status: 'QR_INVALID'
        }
      }
    } else if (code != 200) {
      Toast.fail(msg)
      return Promise.reject('error')
    } else {
      return res.data
    }
  },
  function(error) {
    // 对响应错误做点什么
    let { message } = error
    if (message == 'Network Error') {
      message = '后端接口连接异常'
    } else if (message.includes('timeout')) {
      message = '系统接口请求超时'
    } else if (message.includes('Request failed with status code 401')) {
      Dialog.confirm({
        showCancelButton: false,
        title: '温馨提示',
        message: '登录状态已过期,请重新登陆'
      }).then(() => {
        store.dispatch('LogOut').then(() => {
          router.replace({
            path: '/login',
            query: {
              redirect: router.currentRoute.fullPath
            }
          })
        })
      })

      return
    } else if (message.includes('Request failed with status code')) {
      message = '系统接口' + message.substr(message.length - 3) + '异常'
    }
    return Promise.reject(message)
  }
)

export default server



// WEBPACK FOOTER //
// ./src/utils/request.js